module.exports = __webpack_public_path__ + "static/trevor-profile-pic-795dfa747cf1c5dd6fb5db1925d28a3c.jpg";